import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, CustomDrawer } from 'components/ui';
import { useLocalStore } from 'hooks/';
import { ToggleStateStore } from 'stores/common';
import { useEditFormStore } from 'stores/local';

import { FieldColumns } from './common';
import { DrawerTitle, MyFields, RequiredFields } from './components';

const FieldsCatalogDrawer: React.FC = () => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  const showOnlySelectedStore = useLocalStore(() => new ToggleStateStore());

  const close = React.useCallback(() => {
    editFormStore.catalogDrawerControllerStore.cancel();
  }, [editFormStore.catalogDrawerControllerStore]);

  return (
    <CustomDrawer
      extra={
        <SpacingRow>
          <Button
            onClick={
              editFormStore.catalogDrawerControllerStore.choosePreviousSelection
            }
            disabled={editFormStore.catalogDrawerControllerStore.isDataChanged}
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={editFormStore.mergeData}
            type="primary"
            disabled={editFormStore.catalogDrawerControllerStore.isDataChanged}
          >
            {t('common.save')}
          </Button>
        </SpacingRow>
      }
      title={<DrawerTitle showOnlySelectedStore={showOnlySelectedStore} />}
      onClose={close}
      opened={editFormStore.catalogDrawerControllerStore.opened}
    >
      <RequiredFields showOnlySelected={showOnlySelectedStore.opened} />
      <MyFields showOnlySelected={showOnlySelectedStore.opened} />
      <CustomDrawer.Body>
        <FieldColumns
          showOnlySelected={showOnlySelectedStore.opened}
          showGroupTitles
          catalogDrawerControllerStore={
            editFormStore.catalogDrawerControllerStore
          }
          fields={editFormStore.formStore.catalogStore.data.commonFields}
        />
      </CustomDrawer.Body>
    </CustomDrawer>
  );
};

export default observer(FieldsCatalogDrawer);
